import React, { useState } from "react";
import { Modal, Button } from 'react-bootstrap';
import SwitchYesItem from './SwitchYesItem';

import '../modal.css';
import './SwitchYesModal.css';

const SwitchYesModal = (props) => {
    const [ show, setShow ] = useState(props.show || true);
    
    let bcp = props.data.beginMilepost && {
        name: props.data.beginMilepost.controlPointName,
        switchYesMP: props.data.beginMilepost.milepost + props.data.beginMilepost.milepostSuffix || '',
        switchYes: props.data.beginMilepost.switchYes
    };

    let ecp = props.data.endMilepost && {
        name: props.data.endMilepost.controlPointName,
        switchYesMP: props.data.endMilepost.milepost + props.data.endMilepost.milepostSuffix || '',
        switchYes: props.data.endMilepost.switchYes
    };

    const handleCancel = () => {
        setShow(false);
        props.onCancel && props.onCancel();
    }

    const handleApply = () => {
        setShow(false);

        props.onApply && props.onApply({ bcp, ecp });
    }

    return (
        <Modal className='clsYesNoModal' show={show} onHide={ handleCancel }>
            <Modal.Header>
                <Modal.Title className='clsModal_title warn'>Switch Yes</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className="clsSwitchYes-note">After switch yes applied, below are the new control points and milepost values.</div>

                { bcp ? 
                    <div className="clsSwitchYes-section">
                        <SwitchYesItem label='BMP' value={ bcp.switchYesMP }/>
                        <SwitchYesItem label='BCP' value={ bcp.name }/>
                        <div>{ bcp.switchYes ? 'Switch Yes' : 'Switch No' }</div>
                    </div>
                    : 
                    <div className="clsSwitchYes-section">No changes to begin milepost and control point.</div>
                }

                { ecp ? 
                    <div className="clsSwitchYes-section">
                        <SwitchYesItem label='EMP' value={ ecp.switchYesMP }/>
                        <SwitchYesItem label='ECP' value={ ecp.name }/>
                        <div>{ ecp.switchYes ? 'Switch Yes' : 'Switch No' }</div>
                    </div>
                    : <div className="clsSwitchYes-section">No changes to end milepost and control point.</div>
                }

            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={ handleCancel }>
                    CANCEL
                </Button>
                <Button variant="primary" onClick={ handleApply }>
                    APPLY
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default SwitchYesModal;